import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import "./index.css";
import {
  vehicleHistory,
  cleanVehicleHistory,
} from "../../../../services/Store/Actions/manageVehicleAction";
import {
  autoRechargeToggleAction,
  cleanVehicleDetails,
  getFastagWalletBalance,
  getVehicleDetails,
} from "../../../../services/Store/Actions/fastagAction";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Switch from "react-switch";
import SvgImage from "../../../Icons/Icons";
import { ToastContainer, toast } from "react-toastify";
import { sendAnalitics } from "../../../../services/Store/Actions/appActions";
import Map from "../Map";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PowerIcon from "@mui/icons-material/Power";
import PowerOffIcon from "@mui/icons-material/PowerOff";
import { Button } from "reactstrap";
import AddBalanceButton from "../../../Homepage/Buttons/addBalancebutton";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LockIcon from "@mui/icons-material/Lock";
import {
  getGpsDataAction,
  getGpsStatusAction,
  gpsConnectAction,
} from "../../../../services/Store/Actions/fleetActions";
import CircularProgress from '@mui/material/CircularProgress';

function GPSIntegrationPlugin(props) {
  console.log("this are props", props);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { state, location } = useLocation();
  //const customerData = useSelector((state)=>state)
  console.log("LKKKKKKKKKKKKKKKKKKKK", props.user);
  const vehicleData = useSelector((state) => state?.manageVehicle);
  const [clientId, setClientId] = useState("");
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [username1, setUserName1] = useState("");
  const [password1, setPassword1] = useState("");
  const [edit1, setEdit1] = useState(false);
  const [edit2, setEdit2] = useState(false);
  const [edit3, setEdit3] = useState(false);

  const [connected1, setConnected1] = useState(false);
  const [connected2, setConnected2] = useState(false);
  const [connected3, setConnected3] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  const [loader, setLoader] = useState(false);
  const providers = [
    {
      name: "MY EICHER",
      id: "1",
      url: "https://play-lh.googleusercontent.com/HVfVuAct4jo2PGO0nlafbnR7MygrICmK8rQrzZ66zpmCH-J7uyNdSzno4MbdkLTdaXg=w480-h960-rw",
    },
    {
      name: "Tata Motors Fleet Edge",
      id: "2",
      url: "https://play-lh.googleusercontent.com/6usVInOQLt7K7b7gVmKgOWXEDshKY3Iz0Vgj5fL1m28frrWDC2JgjjOR92cMJv9E11s",
    },
    {
      name: "Ashok Leyland i-Alert",
      id: "3",
      url: "https://seeklogo.com/images/A/ashok_leyland-logo-E3FEA1346B-seeklogo.com.png",
    },
    {
      name: "VehicleTrack",
      id: "4",
      url: "https://play-lh.googleusercontent.com/A-NFgNyI9j658x1aKV8Z8vd0FD5yr1aYIzIG0i4i6xnVs7fWk-FfKTm2y4Qy-GEndrg=w480-h960-rw",
    },
  ];
  const { gpsStatus,gpsData } = useSelector((state) => state?.fleet);

  useEffect(() => {
    console.log("visible here...");
    dispatch(
      getGpsStatusAction({}, (res) => {
        console.log("getGpsDataActiongetGpsDataAction", res);
      })
    );
  }, []);

  console.log("gpsStatusgpsStatus", gpsStatus);

  const [selected, setSelected] = useState("");

  const handleClientIdChange = (event) => {
    setClientId(event.target.value);
  };

  const handleUserNameChange = (event) => {
    setUserName(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleUserNameChange1 = (event) => {
    setUserName1(event.target.value);
  };

  const handlePasswordChange1 = (event) => {
    setPassword1(event.target.value);
  };

  const handleSubmit = (event) => {
    console.log("submitteddd");
    setLoader(true);
    let payload;
    if (selected == "1") {
      payload = {
        gpsProvider: "Eicher",
        clientId: clientId,
      };
    } else if (selected == "2") {
      payload = {
        gpsProvider: "Tata",
        userName: username,
        password: password,
      };
    } else if (selected == "3") {
      payload = {
        gpsProvider: "IAlert",
        clientId: clientId,
      };
    }else if (selected == "4") {
      payload = {
        gpsProvider: "VehicleTrack",
        clientId: clientId,
      };
    }
    console.log("payloadeee", payload);
    dispatch(
      gpsConnectAction(payload, (res) => {
        console.log("reponseingpsconnecr", res);
        setClientId("");
        setUserName("");
        setPassword("");
        setUserName1("");
        setPassword1("");
        setLoader(false);
        dispatch(
          getGpsStatusAction({}, (res) => {
            console.log("getGpsDataActiongetGpsDataAction", res);
          })
        );
      })
    );
  };

  return (
    <>
      <div
        className="main-customer-vehicle-detail"
        style={{
          opacity: "1",
          padding: "12px",
        }}
      >
        <div
          class="whiteBackground"
          style={{ height: "1500px", alignItems: "-webkit-center" }}
        >
          <h3 style={{ textAlign: "center", fontWeight: "400" }}>
            Plugin your GPS provider
          </h3>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginLeft: "18px",
            }}
            className="col-12"
          >
            {providers?.map((data) => {
              return (
                <div
                  className="cardInfo3"
                  style={{
                    padding: "20px",
                    margin: "10px",
                    backgroundColor: selected == data.id ? "lightgrey" : null,
                    width: "150px",
                    marginLeft: "40px",
                  }}
                  onClick={() => {
                    setSelected(data.id);
                  }}
                >
                  <img
                    src={data.url}
                    alt=""
                    height={"110px"}
                    width={"110px"}
                    style={{
                      height: "110px",
                      width: "110px",
                    }}
                    onClick={() => {
                      setSelected(data.name);
                    }}
                  />
                </div>
              );
            })}
            {selected != "" ? (
              <div
                className="col-10"
                style={{
                  border: "0.5px solid #E2E2E2",
                  borderRadius: "0.5rem",
                  boxShadow: "0px 4px 20px 0px #25252D1A !important",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: "10px",
                  marginLeft: "40px",
                  backgroundColor: "white",
                  textAlignLast:'center'
                }}
              >
                {selected == "1" ? (
                  <div
                    style={{
                      padding: "16px",
                    }}
                  >
                    <div className="clientId-container">
                      <div className="title">ClientId</div>
                      <input
                        type="text"
                        value={clientId}
                        onChange={handleClientIdChange}
                        placeholder="Enter ClientId"
                        className="text-box input-field"
                        style={{
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <input
                        type="button"
                        className="greenButton Medium text3 "
                        value={loader ? "Please Wait" : "Submit"}
                        disabled={loader}
                        style={{
                          width: "100px",
                          // marginLeft: "120px",
                          backgroundColor: loader && "lightgray",
                        }}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                ) : selected == "2" ? (
                  <div
                    style={{
                      padding: "16px",
                    }}
                  >
                    <div>
                    <div>
                       
                        <input
                          type="text"
                          name="username"
                          value={username}
                          onChange={handleUserNameChange}
                          placeholder="Enter Username"
                          className="input-field"
                          style={{
                            marginLeft: "10px",
                          }}
                        />
                      </div>

                      <div>
                       
                        <input
                          type="password"
                          name="password"
                          value={password}
                          onChange={handlePasswordChange}
                          placeholder="Enter Password"
                          className="input-field"
                          style={{
                            marginLeft: "12px",
                            marginTop: "5px",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                    >
                     
                      <input
                        type="button"
                        className="greenButton Medium text3 "
                        value={loader ? "Please Wait" : "Submit"}
                        disabled={loader}
                        style={{
                          width: "100px",
                          // marginLeft: "120px",
                          backgroundColor: loader && "lightgray",
                        }}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                ) : selected == "3" ? (
                  <div
                    style={{
                      padding: "16px",
                    }}
                  >
                    <div className="clientId-container">
                      <div className="title">ClientId</div>
                      <input
                        type="text"
                        value={clientId}
                        onChange={handleClientIdChange}
                        placeholder="Enter ClientId"
                        className="text-box input-field"
                        style={{
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <input
                        type="button"
                        className="greenButton Medium text3 "
                        value={loader ? "Please Wait" : "Submit"}
                        disabled={loader}
                        style={{
                          width: "100px",
                          // marginLeft: "120px",
                          backgroundColor: loader && "lightgray",
                        }}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                ) :selected == "4" ? (
                  <div
                    style={{
                      padding: "16px",
                    }}
                  >
                    <div className="clientId-container">
                      <div className="title">ClientId</div>
                      <input
                        type="text"
                        value={clientId}
                        onChange={handleClientIdChange}
                        placeholder="Enter ClientId"
                        className="text-box input-field"
                        style={{
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <input
                        type="button"
                        className="greenButton Medium text3 "
                        value={loader ? "Please Wait" : "Submit"}
                        disabled={loader}
                        style={{
                          width: "100px",
                          // marginLeft: "120px",
                          backgroundColor: loader && "lightgray",
                        }}
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}

            {gpsStatus?.data?.map((data) => {
              return (
                <div
                  className="col-10"
                  style={{
                    border: "0.5px solid #E2E2E2",
                    borderRadius: "0.5rem",
                    boxShadow: "0px 4px 20px 0px #25252D1A !important",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: "10px",
                    marginLeft: "40px",
                    backgroundColor: "white",
                    marginTop: "10px",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="div-table-row-gps"
                    style={{
                      margin: "0px 8px 8px",
                    }}
                    // onClick={() => handleClick(d, i)}
                    key={"2"}
                  >
                    <div className="row">
                      <div class=" rowContN col-12 FontNBList row">
                        {/* <div data-letters={firstName_initials.toUpperCase()}> */}
                        <div
                          data-letters-vehicle={"1"}
                          style={{ paddingTop: "5px", width: "50px" }}
                          className="col-4"
                        ></div>

                        <div
                          className="col-6 FontNB20 VehicleShortName"
                          style={{
                            marginLeft: "10px",
                          }}
                        >
                          <span className="">{data?.gpsProvider}</span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <div
                          style={{ paddingTop: "5px", width: "50px" }}
                          className="col-4"
                        >
                          <LockIcon style={{ color: "black" }} />
                        </div>
                        <div
                          className="col-8 VehicleShortName"
                          // style={{ width: "300px" }}
                        >
                          {data?.clientId || data?.userName || ''}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <div
                          style={{ paddingTop: "5px", width: "50px" }}
                          className="col-4"
                        >
                          {data?.status==1 ? <PowerIcon style={{ color: "green" }} />:<PowerOffIcon style={{color:'red'}} />}
                        </div>
                        <div
                          className="col-6 VehicleShortName"
                          style={{ width: "100px" }}
                        >
                          {data?.status==1 ? "Connected" : "Disconnected"}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <div
                          style={{ paddingTop: "5px", width: "50px" }}
                          className="col-4"
                        >
                          {<LocalShippingIcon style={{ color: "#ed752e" }} />}
                        </div>
                        <div
                          className="col-6 VehicleShortName"
                          style={{ width: "100px" }}
                        >
                          {data?.key1}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                  
                      <button
              className="greenButton Medium text3"
              style={{
                width: "100px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative"
              }}
              onClick={() => {
                console.log("clickeddd")
                setLoadingId(data.id);
                
                dispatch(
                  getGpsDataAction({ id:data?.id }, (res) => {
                    console.log("getGpsDataAction response", res);
                    dispatch(
                      getGpsStatusAction({}, (res) => {
                        console.log("getGpsStatusAction response", res);
                        setLoadingId(null); // Reset loading state
                      })
                    );
                  })
                );
              }}
              disabled={loadingId === data.id} // Disable button while loading
            >
              {loadingId === data.id ? (
                <CircularProgress size={24} style={{ color: "green" }} />
              ) : (
                "Live Location"
              )}
            </button>
                
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* <div>
            <div className="">
             
              {path?.length > 0 && path[0]?.length > 0  ?                 <Map
                  fleetId={state?.vehicle?.fleetId}
                  latt={state?.vehicle?.location?.Lat}
                  longg={state?.vehicle?.location?.Long}
                  regNumber={vehRegNo}
                  path={path}
                  setPath={setPath}
                /> : <></>} 
            
            </div>
          </div> */}
      </div>
    </>
  );
}
export default GPSIntegrationPlugin;
